<template>
    <div class="page-content">
        <SketchBreadcrumb pageName="Dashboard proiecte"></SketchBreadcrumb>
        <div class="padding-box">
            <b-overlay :show="exportLoading">
                <div class="white-box">
                    <div class="table-header align-center">
                        <div class="item-table-header">
                            <p class="red-text">Dashboard consultant</p>
                        </div>
                        <div class="item-table-header">
                            <p>Companii înscrise: <span class="green-bold">{{ totalCompanies }}</span></p>
                        </div>
                        <div class="item-table-header">
                            <p>Proiecte finalizate: <span :class="completedCompanies < totalCompanies ? 'red-danger' : 'green-bold'">{{ completedCompanies }}</span> / <span class="green-bold">{{ totalCompanies }}</span>
                            </p>
                        </div>
                        <div class="item-table-header no-border" style="display: flex; flex-direction: row; min-width: 30%!important;">
                            <img src="@/assets/images/sketch_new_consultant_wide.png" class="" alt="">
                            <div style="margin-left: 30px; border-radius: 5px; padding: 4px 20px; cursor: pointer; background: #49cda8; border: 1px solid #49cda8; color: white" @click="exportCompanies()">
                                Exportă
                            </div>
                        </div>
                    </div>
                </div>
                <b-table id="TabelFirme" sticky-header striped hover :items="firme" :fields="fields" head-variant="light">
                    <template v-slot:cell(company)="data">
                        <span>{{ data.value.length > 18 ? data.value.substring(0, 18) + '...' : data.value }}</span>
                    </template>
                    <template v-slot:cell(progress)="data">
                        <span :class="data.value < 100 ? 'red-danger' : 'green-bold'">{{ data.value }}%</span>
                    </template>
                    <template v-slot:cell(score)="data">
                        <span :class="data.value < 70 ? 'red-danger' : 'green-bold'">{{ data.value }}</span>
                    </template>
                    <template v-slot:cell(documents)="data">
                        <b-icon-exclamation-triangle-fill v-if="data.value === 'warn'" :id="'warnIcon'+data.item.id" font-scale="1" class="warn-icon"></b-icon-exclamation-triangle-fill>
                        <b-icon-check-circle-fill v-else-if="data.value === 'success'" font-scale="1" class="success-icon"></b-icon-check-circle-fill>
                        <b-icon-x-circle-fill v-else font-scale="1" class="danger-icon"></b-icon-x-circle-fill>
                        <b-tooltip :target="'warnIcon'+data.item.id" triggers="hover" placement="left">Documentele au date necompletate.</b-tooltip>
                    </template>
                    <template v-slot:cell(budget)="data">
                        <b-icon-exclamation-triangle-fill v-if="data.value === 'warn'" font-scale="1" class="warn-icon"></b-icon-exclamation-triangle-fill>
                        <b-icon-check-circle-fill v-else-if="data.value === 'success'" font-scale="1" class="success-icon"></b-icon-check-circle-fill>
                        <b-icon-x-circle-fill v-else font-scale="1" class="danger-icon"></b-icon-x-circle-fill>
                    </template>
                    <template v-slot:cell(companyProgress)="data">
                        <b-icon-exclamation-triangle-fill v-if="data.value === 'warn'" font-scale="1" class="warn-icon"></b-icon-exclamation-triangle-fill>
                        <b-icon-check-circle-fill v-else-if="data.value === 'success'" font-scale="1" class="success-icon"></b-icon-check-circle-fill>
                        <b-icon-x-circle-fill v-else font-scale="1" class="danger-icon"></b-icon-x-circle-fill>
                    </template>
                    <template v-slot:cell(activity)="data">
                        <b-icon-exclamation-triangle-fill v-if="data.value === 'warn'" font-scale="1" class="warn-icon"></b-icon-exclamation-triangle-fill>
                        <b-icon-check-circle-fill v-else-if="data.value === 'success'" font-scale="1" class="success-icon"></b-icon-check-circle-fill>
                        <b-icon-x-circle-fill v-else font-scale="1" class="danger-icon"></b-icon-x-circle-fill>
                    </template>
                    <template v-slot:cell(objectives)="data">
                        <b-icon-exclamation-triangle-fill v-if="data.value === 'warn'" font-scale="1" class="warn-icon"></b-icon-exclamation-triangle-fill>
                        <b-icon-check-circle-fill v-else-if="data.value === 'success'" font-scale="1" class="success-icon"></b-icon-check-circle-fill>
                        <b-icon-x-circle-fill v-else font-scale="1" class="danger-icon"></b-icon-x-circle-fill>
                    </template>
                    <template v-slot:cell(indicators)="data">
                        <b-icon-exclamation-triangle-fill v-if="data.value === 'warn'" font-scale="1" class="warn-icon"></b-icon-exclamation-triangle-fill>
                        <b-icon-check-circle-fill v-else-if="data.value === 'success'" font-scale="1" class="success-icon"></b-icon-check-circle-fill>
                        <b-icon-x-circle-fill v-else font-scale="1" class="danger-icon"></b-icon-x-circle-fill>
                    </template>
                    <template v-slot:cell(achizitiiCheltuieli)="data">
                        <b-icon-exclamation-triangle-fill v-if="data.value === 'warn'" font-scale="1" class="warn-icon"></b-icon-exclamation-triangle-fill>
                        <b-icon-check-circle-fill v-else-if="data.value === 'success'" font-scale="1" class="success-icon"></b-icon-check-circle-fill>
                        <b-icon-x-circle-fill v-else font-scale="1" class="danger-icon"></b-icon-x-circle-fill>
                    </template>
                    <template v-slot:cell(businessPlan)="data">
                        <b-icon-exclamation-triangle-fill v-if="data.value === 'warn'" font-scale="1" class="warn-icon"></b-icon-exclamation-triangle-fill>
                        <b-icon-check-circle-fill v-else-if="data.value === 'success'" font-scale="1" class="success-icon"></b-icon-check-circle-fill>
                        <b-icon-x-circle-fill v-else font-scale="1" class="danger-icon"></b-icon-x-circle-fill>
                    </template>
                    <template v-slot:cell(consultant)="data">
                        <b-form-group class="has-icon">
                            <b-form-input
                                id="consultantName"
                                ref="consultant"
                                v-model="data.value.name"
                                type="text"
                                placeholder="Nume consultant"
                                @focusout="sendConsultant(data.value.company_id, data.value.name)"
                                @keydown.enter="$event.target.blur()"
                            >
                            </b-form-input>
                            <img src="@/assets/images/M3/M3Sketch/edit.png" class="title-icon">
                        </b-form-group>
                    </template>
                </b-table>
            </b-overlay>
        </div>
    </div>
</template>


<script>
    import LoadingSpinner from '@/common/components/LoadingSpinner'
    import {BFormCheckbox, BTable, BIconX, BIconExclamationTriangleFill, BIconCheckCircleFill, BIconXCircleFill, BFormInput, BFormGroup, BOverlay, BTooltip} from 'bootstrap-vue'
    import axios from '@/helpers/axios';
    import api from '@/helpers/api';
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import _ from 'lodash'
    export default {
        components: {
            SketchBreadcrumb,
            BFormCheckbox,
            BTable,
            BIconX,
            BIconExclamationTriangleFill,
            BIconCheckCircleFill,
            BIconXCircleFill,
            BFormInput,
            BFormGroup,
            LoadingSpinner,
            BOverlay,
            BTooltip
        },
        props: {},
        data() {
            return {
                loading: true,
                selected: 1,
                uploadedDocument: null,
                maxNumberOfFiles: 0,
                filesUploaded: 0,
                consultant: '',
                companies: [],
                fields: [
                    {
                        key: 'id',
                        label: 'Crt',
                        class: 'crtNumber',
                        sortable: true
                    },
                    {
                        key: 'company',
                        label: 'Companie',
                        class: 'company-name',
                        sortable: true
                    },
                    {
                        key: 'progress',
                        label: 'Progres',
                        class: 'progress-number',
                        sortable: true
                    },
                    {
                        key: 'score',
                        label: 'Punctaj',
                        class: 'progress-number',
                        sortable: true
                    },
                    {
                        key: 'documents',
                        label: 'Documente',
                        class: 'progress-icon',
                        sortable: true
                    },
                    {
                        key: 'budget',
                        label: 'Buget proiect',
                        class: 'progress-icon',
                        sortable: true
                    },
                    {
                        key: 'companyProgress',
                        label: 'Companie',
                        class: 'progress-icon',
                        sortable: true
                    },
                    {
                        key: 'activity',
                        label: 'Activități',
                        class: 'progress-icon',
                        sortable: true
                    },
                    {
                        key: 'objectives',
                        label: 'Obiective',
                        class: 'progress-icon',
                        sortable: true
                    },
                    {
                        key: 'indicators',
                        label: 'Indicatori',
                        class: 'progress-icon',
                        sortable: true
                    },
                    {
                        key: 'achizitiiCheltuieli',
                        label: 'Achiziții cheltuieli',
                        class: 'progress-icon',
                        sortable: true
                    },
                    {
                        key: 'businessPlan',
                        label: 'Plan afaceri',
                        class: 'progress-icon',
                        sortable: true
                    },
                    {
                        key: 'consultant',
                        label: 'Consultant',
                        class: 'consultant-input',
                        sortable: true
                    },
                ],
                firme: [],
                completedCompanies: null,
                totalCompanies: null,
                exportLoading: false
            }
        },
        watch: {},
        mounted() {
            this.getCompanies()
        },
        methods: {
            getCompanies() {
                axios.get(api.API_ENDPOINTS.m3companiesStatus)
                    .then(response => {
                        response.data.forEach(companie => {
                            this.firme.push({
                                id: companie.crt,
                                company: companie.name,
                                progress: companie.progres,
                                score: companie.scor,
                                documents: companie.checklist,
                                budget: companie.buget,
                                companyProgress: companie[`compania-mea`],
                                activity: companie.activitati,
                                objectives: companie.obiective,
                                indicators: companie.indicatori,
                                achizitiiCheltuieli: companie['achizitii-cheltuieli'],
                                businessPlan: companie[`plan-de-afaceri`],
                                consultant: {
                                    name: companie.consultant ? companie.consultant : '',
                                    company_id: companie.id
                                }
                            })
                            this.completedCompanies = _.filter(this.firme, v => v.progress === 100).length;
                            this.totalCompanies = this.firme.length
                            this.$store.dispatch('pageLoading/setLoading', false)
                        })
                    }).finally(() => {})
            },
            sendConsultant(id, consultant) {
                axios.post(api.API_ENDPOINTS.m3company + id + '/project', {consultant: consultant})
                    .then(()=>{
                        this.$toast.success('Numele consultantului a fost actualizat.')
                    })
            },
            exportCompanies(){
                this.exportLoading = true
                axios({url:api.API_ENDPOINTS.m3ExportDashboard , method: 'GET', responseType: 'blob'})
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Companii.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        this.exportLoading = false
                    });
            }
        }
    }
</script>

<style>
#TabelFirme .company-name {
    width: 13%;
    max-width: 230px;
}
#TabelFirme .company-name span{
    width: 13%;
    max-width: 230px;
    color: #53596e;
}
#TabelFirme .progress-icon {
    width: 7.9%;
}
#TabelFirme .consultant-input {
    width: 11%;
}
#TabelFirme .progress-number {
    width: 5%;
    max-width: 90px;
}
#TabelFirme .progress-number span{
    font-size: 20px;
}
#TabelFirme .crtNumber {
    width: 4%;
    max-width: 15px;
    font-size: 13px;
    font-weight: inherit;
}
#TabelFirme th{
    font-size: 13px;
    font-weight: inherit;
}
#TabelFirme{
    text-align: center;
}
#TabelFirme td{
    padding: 0.45rem;
    vertical-align: middle;
}
</style>

<style scoped>
.has-icon{
    position: relative;
}
.has-icon img{
    position: absolute;
    top: 0;
    right: 10px;
    opacity: 0.3;
    bottom: 0;
    margin: auto 0;
}
#TabelFirme .red-bold{
    color: #ea8196 !important;
    font-weight: 700;
}
#TabelFirme .green-bold{
    color: #49cda8 !important;
    font-weight: 700;
}
.padding-box {
    padding: 20px 20px 0 20px;
}

.white-box {
    background: #fff;
}
.flex {
    display: flex;
}
.warn-icon{
    color: #ffc43f;
}
.danger-icon{
    color: #ea8196 !important
}
.success-icon{
    color: #49cda8 !important
}
.space-between {
    justify-content: space-between;
}

.justify-content-center {
    justify-content: center;
}

.table-header {
    font-size: 14px;
    color: #5b6276;
    font-weight: 500;
    min-height: 115px;
    padding: 0 20px;
}

tbody span {
    color: #777e90;
    font-size: 12px;
    font-weight: 500;
}
.form-group{
    margin: 0;
}
input{
    border-radius: 0;
    font-size: 13px;
    margin: 5px 0;
    color: #53596e;
    text-align: left;
    background: #e9ecef;
}
input:focus{
    color: #53596e;
    background: #e9ecef;
}
tr {
    text-align: center !important;
}

.absolute-left {
    position: absolute;
    left: 10%;
    bottom: 40%;
    z-index: 0;
}

.icons svg:not(:last-child) {
    margin-right: 10px;
}

.icons svg {
    font-size: 17px;
}

.padding-box .table-responsive {
    overflow-y: auto;
    max-height: calc(100% - 122px);
}
.b-table-sticky-header{
    max-height: calc(100% - 122px);
}
.b-table-sticky-header, .table-responsive {
    margin-bottom: 0;
}

.ml-1 {
    margin-right: 10px;
}

.item-table-header {
    width: 100%;
    height: 100%;
    min-height: 70px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    border-right: 3px dotted #caccd2;
}

.item-table-header:last-child {
    border-right: 0;
}

.item-table-header p {
    font-size: 19px;
    color: #545a6f;
    letter-spacing: -0.3px;
    font-weight: 400;
}

.red-text {
    color: #836e8b !important;
}

.green-bold {
    color: #49cda8 !important;
    font-weight: 700;
}

.red-danger {
    color: #ea8196 !important;
}

@media (max-width: 1500px) {
    .item-table-header p{
        text-align: center;
    }
    .item-table-header img{
        max-height: 30px;
        object-fit: contain;
        padding: 0 10px;
    }
    .white-box {
        padding-right: 0;
    }
}
</style>
